<template>
  <div>
    <Head :title="__('Create a new customer')" />

    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pr-6 pb-8 w-full lg:w-1/3 relative">
            <label class="block text-red-600 mb-1 font-semibold" for="relatienummer_code">
              {{ __('Relatienummer/code*') }}
            </label>
            <TextInput
              v-model="form.relatienummer_code"
              :error="form.errors.relatienummer_code"
              id="relatienummer_code"
              class="w-full"
            />
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/3 relative">
            <label class="block text-red-600 mb-1 font-semibold" for="contractnummer">
              {{ __('Contractnummer*') }}
            </label>
            <TextInput
              v-model="form.contractnummer"
              :error="form.errors.contractnummer"
              id="contractnummer"
              class="w-full"
            />
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/3 relative flex items-center">
            <span class="text-lg text-red-600 font-semibold">* Verplicht</span>
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/3 relative">
            <label class="form-label block mb-1" for="naam">
              {{ __('Naam') }}
            </label>
            <TextInput
              v-model="form.naam"
              :error="form.errors.naam"
              id="naam"
              class="w-full"
            />
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/3 relative">
            <label class="form-label block mb-1" for="adres">
              {{ __('Adres') }}
            </label>
            <TextInput
              v-model="form.adres"
              :error="form.errors.adres"
              id="adres"
              class="w-full"
            />
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/3 relative">
            <label class="form-label block mb-1" for="postcode">
              {{ __('Postcode') }}
            </label>
            <TextInput
              v-model="form.postcode"
              :error="form.errors.postcode"
              id="postcode"
              class="w-full"
            />
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/3 relative">
            <label class="form-label block mb-1" for="plaats">
              {{ __('Plaats') }}
            </label>
            <TextInput
              v-model="form.plaats"
              :error="form.errors.plaats"
              id="plaats"
              class="w-full"
            />
          </div>
        </div>

        <hr class="mx-8 border-gray-300" />

        <div class="p-8">
          <label class="block mb-2 font-semibold">
            {{ __('Of plak ') }}
            <span class="text-red-600">bij voorkeur</span>
            {{ __(' de contractregel uit Clear hier:') }}
          </label>

          <textarea
            v-model="form.raw_clear_string"
            :class="[
              'form-input w-full rounded-md border-gray-300 min-h-[200px]',
              form.errors.raw_clear_string ? 'border-red-500' : ''
            ]"
            rows="5"
          ></textarea>
          <div v-if="form.errors.raw_clear_string" class="text-red-500 mt-1 text-sm">
            {{ form.errors.raw_clear_string }}
          </div>
        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <LoadingButton :loading="form.processing" class="btn-indigo" type="submit">
            {{ __('Create') }}
          </LoadingButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    TextInput,
    LoadingButton,
  },
  layout: Layout,
  data() {
    return {
      form: this.$inertia.form({
        relatienummer_code: '',
        contractnummer: '',
        naam: '',
        adres: '',
        postcode: '',
        plaats: '',
        raw_clear_string: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('customers.store'))
    },
  },
}
</script>
